require('./alpine.js');

import './carousel.js';
// The global add-to-cart handler (it used to arrive through account/products.js,
// which is now its own bundle, account-legacy.js, for the old account pages only).
import './add-to-cart.js';
import './ghs-warnings.js';
import './store-status.js';
import './store-share.js';
import './a11y.js';
import './torg-pricing.js';
import './policy-nav.js';
// checkout.js is now loaded separately via Checkout.controller.php for checkout pages only
// Removed: import './checkout.js';

import '../sass/main.scss';
import '../sass/fonts.scss';
import '../sass/confetti.scss';
import '../sass/woobt.scss';
import '../sass/waiting-list.scss';
import '../sass/support.scss';
import '../sass/policies.scss';
import '../sass/account.scss';

import logo from '../img/lysiq-logo-simplified.svg'
import logo2 from '../img/lysiq-logo-simplified-2.svg'
import logo3 from '../img/lysiq-logo-simplified-3.svg'
import logo4 from '../img/lysiq-logo-simplified-4.svg'
import symbol from '../img/lysiq-symbol.svg'
import homey from '../img/homey.png'
import futurehome from '../img/futurehome.png'
import lysiq3dsymbol from '../img/lysiq-symbol-3d.jpg'
import lysiq3dsymbol2 from '../img/lysiq-symbol-3d-2.jpg'
import lysiqmenubg from '../img/lysiq-menu-bg.jpg'
import appstoreSwedish from '../img/app-store-swedish.svg'
import googleplaySwedish from '../img/google-play-swedish.png'
import placeholder from '../img/placeholder.jpeg'
import vapeslogo from '../img/vapes-logo-2017-black.svg'

window.onlyOneSearchFilterCheckbox = function (checkbox) {
    var checkboxes = document.getElementsByName('search-filters')
    Array.from(checkboxes).forEach((item) => {
        if (item !== checkbox) item.checked = false
    })
};

/**
 * Hello Retail URL Rewriter (for local development only)
 * Rewrites staging/production URLs to current domain in search results
 */
;(function() {
    const currentHost = window.location.hostname;
    const productionDomains = ['staging.vapes.se', 'www.vapes.se', 'vapes.se', 'staging.lysiq.se', 'www.lysiq.se', 'lysiq.se'];

    // Only run on local dev environments
    if (productionDomains.includes(currentHost)) {
        return;
    }

    function rewriteUrl(url) {
        let newUrl = url;
        // Order matters: more specific domains first
        const domainsToReplace = ['staging.vapes.se', 'www.vapes.se', 'vapes.se', 'staging.lysiq.se', 'www.lysiq.se', 'lysiq.se'];
        for (const domain of domainsToReplace) {
            if (newUrl.includes(domain)) {
                newUrl = newUrl.replace(domain, currentHost);
                break; // Only replace once
            }
        }
        return newUrl;
    }

    function rewriteLinksInElement(element) {
        const links = element.querySelectorAll('a[href]');
        links.forEach(link => {
            const href = link.getAttribute('href');
            if (href && productionDomains.some(domain => href.includes(domain))) {
                link.setAttribute('href', rewriteUrl(href));
            }
        });
    }

    function initUrlRewriter() {
        // Watch for Hello Retail search results
        const searchResultsContainer = document.getElementById('hr-search-results');
        if (searchResultsContainer) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            rewriteLinksInElement(node);
                        }
                    });
                });
            });

            observer.observe(searchResultsContainer, {
                childList: true,
                subtree: true
            });

            // Also intercept clicks as fallback (for dynamically added links)
            searchResultsContainer.addEventListener('click', function(e) {
                const link = e.target.closest('a[href]');
                if (link) {
                    const href = link.getAttribute('href');
                    if (href && productionDomains.some(domain => href.includes(domain))) {
                        e.preventDefault();
                        window.location.href = rewriteUrl(href);
                    }
                }
            }, true);
        }
    }

    // Run when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initUrlRewriter);
    } else {
        initUrlRewriter();
    }
})();


Array.from(document.getElementsByClassName("expander")).forEach(function(element) {
    element.addEventListener('click', (expander) => {
        let target = document.getElementById(element.getAttribute('data-expand'))
        target.classList.remove('hidden');
        element.classList.add('hidden');
    });
  });



/* Cart */ 
jQuery(".crossell-link").on("click", function (e) {
    e.preventDefault();
    const href = jQuery(this).attr("href");
    jQuery("html, body").animate({ scrollTop: jQuery(href).offset().top - 50 }, 800);
});

jQuery(document).on('click', '.ajax_remove_from_cart', function (e) {
    e.preventDefault();

    var product_id = jQuery(this).attr("data-product_id"),
        cart_item_key = jQuery(this).attr("data-cart_item_key"),
        product_container = jQuery(this).parents('.cart-product');

    jQuery.ajax({
        type: 'POST',
        dataType: 'json',
        url: wc_add_to_cart_params.ajax_url,
        data: {
            action: "product_remove",
            product_id: product_id,
            cart_item_key: cart_item_key,
            initiator: window.location.href
        },
        success: function(response) {
            if ( ! response || response.error )
                return;

            var fragments = response.fragments;

            // Replace fragments
            if ( fragments ) {
                jQuery.each( fragments, function( key, value ) {
                    jQuery( key ).replaceWith( value );
                });
            }
    
            // Update cart
            jQuery( document.body ).trigger( 'wc_update_cart' );
            jQuery( document.body ).trigger( 'update_checkout' );
        }
    });
});


jQuery(document).on('change', '.ajax_product_quantity', function (e) {
    e.preventDefault();

    // Stepper limits from mini-cart.component.php (versa_cart_item_qty_limits()): Torg Pricing
    // pack lines step by whole packs (step = min = N); max is the stock or Torg Pricing's
    // limit for the line (a pack line whose tier was removed cannot be increased).
    // A pack line shown as packs counts packs (data-qty-factor = N): the cart gets value × N.
    const step = parseInt(this.getAttribute('step'), 10) || 1;
    const min = Math.max(step, parseInt(this.getAttribute('min'), 10) || 1);
    const max = parseInt(this.getAttribute('max'), 10) || Infinity;
    const factor = parseInt(this.dataset.qtyFactor, 10) || 1;
    const wanted = Math.ceil((parseInt(this.value, 10) || min) / step) * step;
    this.value = Math.max(min, Math.min(max, wanted));

    jQuery(this).prop('disabled', true)
    jQuery(this).siblings().prop('disabled', true)
    jQuery(this).closest('.cart-product').first().children('.thumbnail').addClass('loading transition-opacity opacity-10 pointer-events-none')
    jQuery(this).closest('.cart-product').first().children('.info').addClass('loading transition-opacity opacity-10 pointer-events-none')
    jQuery(this).closest('.cart-product').first().children('.spinner').first().removeClass('hidden')

    jQuery.ajax({
        type: 'POST',
        dataType: 'json',
        url: wc_add_to_cart_params.ajax_url,
        data: {
            action: "update_item_from_cart",
            quantity: (parseInt(jQuery(this).val(), 10) || min) * factor,
            cart_item_key: jQuery(this).attr("data-cart_item_key"),
            initiator: window.location.href
        },
        success: function(response) {
            if ( ! response || response.error ) {
                console.log(response.error);
                return;
            }

            var fragments = response.fragments;

            // Replace fragments
            if ( fragments ) {
                jQuery.each( fragments, function( key, value ) {
                    jQuery( key ).replaceWith( value );
                });
            }
    
            // Update cart
            jQuery( document.body ).trigger( 'wc_update_cart' );
            jQuery( document.body ).trigger( 'update_checkout' );

            jQuery(this).removeClass('loading')

        }
    });
});


jQuery(document).on('change', 'input[name="rate"]', function (e) {
    jQuery('#checkout-cart, #cart-totals, #coupons').addClass('loading transition-opacity opacity-10 pointer-events-none')
    jQuery.ajax({
        type: 'POST',
        dataType: 'json',
        url: wc_add_to_cart_params.ajax_url,
        data: {
            action: "update_shipping_method",
            shipping_method: jQuery(this).val(),
            initiator: window.location.href
        },
        success: function(response) {
            if ( ! response || response.error )
                return;

            var fragments = response.fragments;

            // Replace fragments
            if ( fragments ) {
                jQuery.each( fragments, function( key, value ) {
                    jQuery( key ).replaceWith( value );
                });
            }
    
            // Update cart
            jQuery( document.body ).trigger( 'wc_update_cart' );
            jQuery( document.body ).trigger( 'update_checkout' );
        }
    });
})

jQuery(document).on('click', '#coupon_code_submit', function (e) {
    // Skip on checkout pages - checkout.js handles this
    if (jQuery('.checkout-container').length > 0 || jQuery('body').hasClass('woocommerce-checkout')) {
        return;
    }

    e.preventDefault();

    var couponCode = jQuery('#coupon_code').val();
    var nonce = jQuery('#coupon_code_nonce').val();

    jQuery.ajax({
        type: 'POST',
        dataType: 'json',
        url: wc_add_to_cart_params.ajax_url,
        data: {
            action: 'ajax_apply_coupon',
            coupon_code: couponCode,
            security: nonce
        },
        success: function(response) {
            if ( ! response || response.error ) {
                console.log(response.error);
                return;
            }

            var fragments = response.fragments;

            // Replace fragments
            if ( fragments ) {
                jQuery.each( fragments, function( key, value ) {
                    jQuery( key ).replaceWith( value );
                });
            }

            // Update cart
            jQuery( document.body ).trigger( 'applied_coupon_in_checkout' );
        }
    });
});


jQuery('body').on('applied_coupon_in_checkout removed_coupon_in_checkout', function (e) {

    jQuery('#checkout-cart, #cart-totals, #coupons').addClass('loading transition-opacity opacity-10 pointer-events-none')
    
    jQuery.ajax({
        type: 'POST',
        dataType: 'json',
        url: wc_add_to_cart_params.ajax_url,
        data: {
            action: "refresh_coupon",
            initiator: window.location.href
        },
        success: function(response) {
            if ( ! response || response.error )
                return;

            var fragments = response.fragments;

            // Replace fragments
            if ( fragments ) {
                jQuery.each( fragments, function( key, value ) {
                    jQuery( key ).replaceWith( value );
                });
            }
    
            // Update cart
            //jQuery( document.body ).trigger( 'wc_update_cart' );
            jQuery( document.body ).trigger( 'update_checkout' );
            jQuery('#coupons').removeClass('loading')
        }
    });

});

function setValueUnencoded(url, key, value, action) {
    url.searchParams.set(key, value);
    const entries = Array.from(url.searchParams.entries());
    url.search = "";
    entries.forEach(item => {
        if (item[0] === key) { return; }
        url.searchParams.set(item[0], item[1]);
    });
    url.search += `${key}=${value}`;
}

function processFormForURL(form) {

    let filter = '';
    let filters = {};
    let sorting = '';
    
    form.forEach(element => {
        if (element.name === 'sorting') {
            sorting = element.value;
        }
        if (element.value === '') return;
        if (element.value === 'on') element.value = true;
        if (element.value === 'off') element.value = false;
        if (typeof element.value === "string") {

            element.value = element.value.replace(" ", "%20")
            element.value = element.value.replace("%28", "(")
            element.value = element.value.replace("%29", ")")


            element.value = element.value.replace(/(&|&amp;| )/g, function(match) {
            if (match === ' ') {
                return '%20';
            } else if (match === '%2B') {
                return '+';
            } else {
                return '%26';
            }});
        }

        if (typeof filters[element.name] !== 'undefined') {
            filters[element.name] += "," + element.value;

        } else {
            filters[element.name] = element.value;
        }
    });

    let filterIndex = 0;

    for (const [key, value] of Object.entries(filters)) {
        if (filterIndex > 0) filter += ';';
        filter += key + ':' + value;
        filterIndex++;
    }

    const url = new URL(window.location.href);

    if (filter == '') {
        url.searchParams.delete('query');
    } else {
        if (window.location.href.indexOf("?s=") > -1) {
            setValueUnencoded(url, '&query', filter);
        } else {
            setValueUnencoded(url, 'query', filter);
        }
    }

    window.history.replaceState(null, null, url);

    return {
        'filters': filter,
        'sorting': sorting
    };

}

function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

function removeValueFromQueryString(query, key, value) {
    // Split the query by semicolon (;) to get individual key-value pairs
    const keyValuePairs = query.split(';');
  
    // Iterate over each key-value pair
    const updatedKeyValuePairs = keyValuePairs.map((pair) => {
      // Split the pair by colon (:) to get the key and value
      const [pairKey, pairValue] = pair.split(':');
  
      // Check if the pair key and value match the provided key and value
      if (pairKey === key && pairValue.includes(value)) {
        // Split the pair value by comma (,) to get individual values
        const pairValues = pairValue.split(',');
  
        // Remove the provided value from the pair values
        const updatedValues = pairValues.filter((v) => v !== value);
  
        // Join the updated values with comma (,) to form the new pair value
        const updatedPairValue = updatedValues.join(',');
  
        // Return the updated key-value pair
        return `${pairKey}:${updatedPairValue}`;
      }
  
      // Return the original key-value pair if no update is needed
      return pair;
    });
  
    // Join the updated key-value pairs with semicolon (;) to form the new inputString
    const updatedInputString = updatedKeyValuePairs.join(';');
  
    return updatedInputString;
  }



jQuery('body').on('keyup change paste', '#hr-form input, #hr-form select, #hr-form textarea', function(e){
    e.preventDefault();

    var start_time = new Date().getTime();
    var paramsString = processFormForURL(jQuery('#hr-form').serializeArray());

    const urlParams = new URLSearchParams(window.location.search);
    const searchParam = urlParams.get('s');

    var breadcrumbs = null;
    var breadcrumbsQuery = "";

    // if current URL has the query "s=" in the querystring return
    if (window.location.href.indexOf("?s=") > 0) {
    } else {
        breadcrumbs = document.getElementById('hr-breadcrumbs').value.replace(/(&|&amp;| )/g, function(match) {
            if (match === ' ')
                return '%20';
            else
                return '%26';
        });

        if (breadcrumbs !== "null") {
            breadcrumbsQuery = "&breadcrumbs="+breadcrumbs
        }
    }

    let extra = "";
    const key_src = jQuery("#hr_key_src").val();

    if( key_src === "custom_field" ) {
        extra += "&key_src="+jQuery("#hr_key_src").data('post-id');
    }

    var extendedBaseFilterEl = document.getElementById('hr-extended-base-filter');
    if (extendedBaseFilterEl && extendedBaseFilterEl.value && extendedBaseFilterEl.value !== "[]") {
        extra += "&extendedBaseFilter=" + encodeURIComponent(extendedBaseFilterEl.value);
    }

    console.log("?hr-ajax&locale="+ajax_var.locale+"&query="+paramsString['filters']+breadcrumbsQuery+extra)

    jQuery(this).prop('disabled', true)
    jQuery(this).siblings().prop('disabled', true)
    jQuery("#hr-page-container").addClass('loading transition-opacity opacity-70 pointer-events-none').children('.spinner').first().removeClass('hidden')
    jQuery("#hr-options").addClass('loading transition-opacity opacity-70 pointer-events-none').children('.spinner').first().removeClass('hidden')

    if (window.location.href.indexOf("?s=") > -1) {
        getData("/" + "?hr-search-ajax&locale="+ajax_var.locale+"&query="+searchParam+"&filters="+paramsString['filters']).then(data => {
            var parsedData = JSON.parse(data);
            var html = new DOMParser().parseFromString(parsedData.html, "text/html");
            jQuery( '#hr-page' ).replaceWith( html.firstChild.innerHTML );
        }).catch((error) => {
            console.error(error);
        });
    } else {

        getData("/" + "?hr-ajax&locale="+ajax_var.locale+"&query="+paramsString['filters']+breadcrumbsQuery+extra).then(data => {
            var parsedData = JSON.parse(data);
            var html = new DOMParser().parseFromString(parsedData.html, "text/html");
            jQuery( '#hr-page' ).replaceWith( html.firstChild.innerHTML );
        }).catch((error) => {
            console.error(error);
        });
    }
    
});


async function getData(url = "", data = {}) {
    // Default options are marked with *
    const response = await fetch(url, {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        mode: "same-origin", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    });
    return response.text(); // parses JSON response into native JavaScript objects
}

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
}
